module.exports = __webpack_public_path__ + "img/speaker-only.d613287c.svg";